import ARMToSPIRE from './CustomLevelMappings/ARMToSPIRE';
export default function getARMToCustomLevelMap(partner) {
  if(partner && partner.toLowerCase() === 'spire') {
    return ARMToSPIRE;
  }

  return null;
}